import axiosInstance from "../../utils/config/config";

export const getAllLessons = () => async (dispatch) => {
  try {
    dispatch({
      type: "lessonsRequest",
    });

    const response = await axiosInstance.get("/courselessons/all");

    if (response.status === 200) {
      dispatch({
        type: "lessonsSuccess",
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: "lessonsFailure",
      payload: false,
    });
    console.error("Failed to fetch all lessons", error);
  }
};
